(function(){
  var box = document.getElementById('quizBox');
  if(!box) return;

  var A = {}, STEPS = 3;
  var SKU_IDX = { tincture:0, mint:0, gummies:1, capsules:2, tea:3 };
  var META = {
    tincture:{n:'BetterLungs® Mullein + Chlorophyll'},
    gummies:{n:'BetterLungs® Mullein Gummies'},
    capsules:{n:'BetterLungs® Daily Capsules'},
    tea:{n:'BetterLungs® Detox Tea'},
    liver:{n:'BetterLiver Hepatic Tincture'}
  };
  var ORDER = { tincture:4, capsules:3, gummies:2, tea:1 };

  function show(step){
    box.querySelectorAll('.quiz-step,.quiz-result').forEach(function(s){ s.hidden = (s.getAttribute('data-step') !== String(step)); });
  }

  function computeSupport(){
    var lung=false, liver=false, goal=null;
    box.querySelectorAll('.quiz-opt.on').forEach(function(b){
      var c = b.getAttribute('data-cat');
      if(c==='lung'){ lung=true; if(!goal) goal=b.getAttribute('data-goal'); }
      else if(c==='liver'){ liver=true; }
    });
    A.support = (liver && lung) ? 'both' : (liver ? 'liver' : 'lungs');
    A.goal = goal || 'everyday';
  }

  // score each product on need (goal), then let the supplement-struggle answer refine the pick
  function scoreAll(){
    var s = { tincture:0, gummies:0, capsules:0, tea:0 };
    function add(m){ if(!m) return; for(var k in m){ s[k]+=m[k]; } }
    add(({everyday:{tincture:3,capsules:1}, mucus:{tincture:3,capsules:2,tea:2}, breath:{capsules:2,tincture:1,gummies:1}})[A.goal]);
    add(({taste:{gummies:6,tea:-2}, consistency:{gummies:6}, pills:{capsules:-8,tincture:3,gummies:3,tea:2}, price:{tincture:3,tea:2}, proof:{tincture:8}})[A.barrier]);
    return s;
  }

  function ranked(){
    var s = scoreAll();
    var arr = [['tincture',s.tincture],['gummies',s.gummies],['capsules',s.capsules],['tea',s.tea]];
    arr.sort(function(a,b){ return (b[1]-a[1]) || (ORDER[b[0]]-ORDER[a[0]]); });
    return arr.map(function(x){ return x[0]; });
  }

  function imgFor(sku){
    if(sku==='liver'){ var li=document.querySelector('#liver .liver-media img'); return li ? li.src : ''; }
    var cards = document.querySelectorAll('#shop .pgrid .card');
    var c = cards[SKU_IDX[sku]];
    return (c && c.querySelector('img')) ? c.querySelector('img').src : '';
  }

  function fillCombo(aId,anId,bId,bnId,skuA,skuB){
    var ea=document.getElementById(aId), en=document.getElementById(anId);
    var eb=document.getElementById(bId), ebn=document.getElementById(bnId);
    if(!ea||!en||!eb||!ebn) return;
    ea.src=imgFor(skuA); ea.alt=META[skuA].n; en.textContent=META[skuA].n;
    eb.src=imgFor(skuB); eb.alt=META[skuB].n; ebn.textContent=META[skuB].n;
  }

  function renderResult(){
    computeSupport();
    var r = ranked(), support = A.support || 'lungs', c1, c2;
    if(support === 'lungs'){ c1=[r[0], r[1]]; c2=[r[0], r[2]]; }
    else { c1=['liver', r[0]]; c2=['liver', r[1]]; }
    fillCombo('c1a','c1an','c1b','c1bn', c1[0], c1[1]);
    fillCombo('c2a','c2an','c2b','c2bn', c2[0], c2[1]);
    var blurb = document.getElementById('c1blurb');
    if(blurb){
      blurb.textContent = (support === 'lungs')
        ? 'Two BetterLungs formats that stack for daily respiratory support.'
        : 'BetterLiver for daily liver and digestion support, paired with your best-fit BetterLungs formula.';
    }
    show('result');
  }

  box.addEventListener('click', function(e){
    var cont = e.target.closest('.q-continue');
    if(cont){ var cs = parseInt(cont.closest('.quiz-step').getAttribute('data-step'), 10); show(cs+1); return; }
    var opt = e.target.closest('.quiz-opt');
    if(opt){
      var stepEl = opt.closest('.quiz-step'), step = parseInt(stepEl.getAttribute('data-step'), 10);
      if(stepEl.getAttribute('data-multi')){ opt.classList.toggle('on'); return; }
      A[opt.getAttribute('data-k')] = opt.getAttribute('data-v');
      if(step < STEPS-1){ show(step+1); return; }
      renderResult(); return;
    }
    if(e.target.id === 'qrRetake'){ A={}; box.querySelectorAll('.quiz-opt.on').forEach(function(x){ x.classList.remove('on'); }); show(0); }
  });
})();
